module.exports = __webpack_public_path__ + "img/lo.337e3271.svg";